import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-952ebab2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex mb-4 md:mb-8 mt-4 md:mt-8" }
const _hoisted_2 = { class: "flex min-h-20 sm:items-center text-left px-8 py-4 bg-white dark:bg-gray-800" }
const _hoisted_3 = { class: "flex w-full justify-evenly flex-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChTypography = _resolveComponent("ChTypography")!
  const _component_ChIcon = _resolveComponent("ChIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ChTypography, {
        "as-tag": "h3",
        variant: _ctx.isDesktop ? 'Untitled20Medium' : 'Untitled18Medium',
        class: "text-black dark:text-white"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('home.footer.title')), 1)
        ]),
        _: 1
      }, 8, ["variant"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footer, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: "flex items-center cursor-pointer my-2 item-container",
            onClick: ($event: any) => (_ctx.onClickItem(item))
          }, [
            (item.to)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: item.to,
                  class: "flex items-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ChIcon, {
                      icon: item.icon,
                      "icon-type": item.iconType
                    }, null, 8, ["icon", "icon-type"]),
                    _createVNode(_component_ChTypography, {
                      "as-tag": "span",
                      variant: "Untitled16Regular",
                      class: "pl-2 text-black dark:text-white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t(item.text)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: item.externalLink,
                  target: "_blank",
                  class: "flex items-center"
                }, [
                  _createVNode(_component_ChIcon, {
                    icon: item.icon,
                    "icon-type": item.iconType
                  }, null, 8, ["icon", "icon-type"]),
                  _createVNode(_component_ChTypography, {
                    "as-tag": "span",
                    variant: "Untitled16Regular",
                    class: "pl-2 text-black dark:text-white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t(item.text)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ], 8, _hoisted_5))
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ], 64))
}